import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CategoryService } from '@app/api/api';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'environments/environment';

@Component({
  selector: 'meu-app-modal-edit-catalog',
  templateUrl: './app-modal-edit-catalog.component.html',
  styleUrls: ['./app-modal-edit-catalog.component.scss'],
})
export class AppModalEditCatalogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private categoryService: CategoryService,
    private toastrService: ToastrService,
    public dialogRef: MatDialogRef<AppModalEditCatalogComponent>
  ) {}
  filesLogo: File[] = [];
  isChangeLogo = false;
  hasFormErrors: boolean = false;
  logo;
  labelAllParentsName: any = [];
  catalogForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    parent_id: new FormControl(''),
    priority: new FormControl(''),
  });
  ngOnInit() {
    this.renderListNameCategories();
    if (this.data.type == 'edit') {
      this.getCatalogById();
    }
  }
  getCatalogById() {
    this.categoryService.apiCategoriesIdGet(this.data.selectedNodeId).subscribe((res) => {
      if (res.success) {
   
        this.catalogForm.patchValue({
          name: res.data.name,
          parent_id: res.data.parent_id,
          priority: res.data.priority,
        });
        if (res.data.image) {
          this.logo = environment.backendhost + res.data.image;
        }
      }
    });
  }
  saveCatalogChange() {
    const controls = this.catalogForm.controls;

    this.catalogForm.value.priority = +this.catalogForm.value.priority;
    if (this.catalogForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      //this.hasFormErrors = true;
      return;
    } else {
      this.categoryService
        .apiCategoriesIdPut(this.data.selectedNodeId, this.catalogForm.value)
        .subscribe((res) => {
          if (res.success) {
            if (this.filesLogo.length > 0) {
              let file: File = this.filesLogo[0];
              this.categoryService
                .apiCategoriesIdImagePut(res.data.id, file)
                .subscribe((resImage) => {
                  if (resImage.success) {
                    this.toastrService.success('Chỉnh sửa danh mục thành công');
                    this.dialogRef.close({ event: true, item: res.data, type: 'edit' });
                  }
                });
            } else {
              this.dialogRef.close({ event: true, item: res.data, type: 'edit' });
              this.toastrService.success('Chỉnh sửa danh mục thành công');
            }
          } else {
            this.toastrService.error('Chỉnh sửa danh mục không thành công');
          }
        });
    }
  }
  createNewCatalog() {

    const controls = this.catalogForm.controls;

    this.catalogForm.value.priority = +this.catalogForm.value.priority;
    this.catalogForm.value.parent_id = this.catalogForm.value.parent_id;
    if (this.catalogForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      //this.hasFormErrors = true;
      return;
    } else {
      this.catalogForm.patchValue({ parent_id: this.data.selectedNodeId });
      this.categoryService.apiCategoriesPost(this.catalogForm.value).subscribe((res) => {
        if (res.success) {
          if (this.filesLogo.length > 0) {
            let file: File = this.filesLogo[0];
            this.categoryService
              .apiCategoriesIdImagePut(res.data.id, file)
              .subscribe((resImage) => {
                if (resImage.success) {
                  this.toastrService.success('Thêm danh mục thành công');
                  this.dialogRef.close({ event: true, item: res.data });
                }
              });
          } else {
            this.dialogRef.close({ event: true, item: res.data });
            this.toastrService.success('Thêm danh mục thành công');
          }
        }
      });
    }
  }
  // dropzone
  onSelectLogo(event) {
    this.filesLogo = [];
    this.filesLogo.push(...event.addedFiles);
    this.isChangeLogo = true;
    this.logo = null;
  }
  onRemoveLogo(event) {
    this.filesLogo.splice(this.filesLogo.indexOf(event), 1);
  }
  //end dropzone
  renderListNameCategories() {
    let listNameCategories = this.data.lstParentName.slice().reverse();
    if (listNameCategories.length > 3) {
      this.labelAllParentsName.push('...');
      this.labelAllParentsName.push(listNameCategories[listNameCategories.length - 3]);
      this.labelAllParentsName.push(listNameCategories[listNameCategories.length - 2]);
      this.labelAllParentsName.push(listNameCategories[listNameCategories.length - 1]);
    } else {
      this.labelAllParentsName = listNameCategories;
    }
  }
}
